const planName = newPricing => {
  const pricing = newPricing || {}
  if (pricing.pro?.isSubscribed) return 'Pro Plan'
  if (pricing.growth?.isSubscribed) return 'Growth Plan'
  if (pricing.starter?.isSubscribed) return 'Starter Plan'
  return 'Free Plan'
}

const parseUkDate = value => {
  const match = String(value || '').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  if (!match) return null
  return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]))
}

const parseIsoDate = value => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return null
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

/** Narrow the venues used to fill a group. Dates are the card format or yyyy-mm-dd. */
export const filterVenuesForGroupFill = (venues, filters = {}) => {
  const plan = filters.plan && filters.plan !== 'all' ? filters.plan : ''
  const brand = filters.brand && filters.brand !== 'all' ? filters.brand : ''
  const activity =
    filters.activity && filters.activity !== 'all' ? filters.activity : ''
  const before =
    parseIsoDate(filters.orderedBefore) || parseUkDate(filters.orderedBefore)
  const brands = filters.brands || new Map()
  return (venues || []).filter(venue => {
    if (plan && planName(venue.newPricing) !== plan) return false
    if (brand) {
      const known = brands.get(String(venue._id)) || ''
      if (known !== brand) return false
    }
    if (activity && venue.activityColor !== activity) return false
    if (before) {
      const last = parseUkDate(venue.lastOrderDate)
      if (!last || last >= before) return false
    }
    return true
  })
}
